const $ = jQuery

export default function Newsroom () {
  const WRAPPERS = document.querySelectorAll('.mtt-newsroom')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = new NewsroomWrapper(WRAPPERS[i])
      WRAPPER.init()
    }
  }
}

class NewsroomWrapper {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.LOADER = this.WRAPPER.querySelector('.mtt-newsroom__loader')
    this.PAGINATION_TARGET = this.WRAPPER.querySelector('.mtt-newsroom__pagination-target')
    this.TARGET = this.WRAPPER.querySelector('.mtt-newsroom__articles')

    this.url = this.WRAPPER.getAttribute('data-main-url')

    this.data = {
      action: 'filter_newsroom',
      pagenumber: 1,
      published: this.getFirstYear(),
      category: this.getFirstCategory()
    }
  }

  init () {
    this.yearsHandler()
    this.categoriesHandler()
    this.paginationHandler()
  }

  yearsHandler () {
    const YEARS = this.WRAPPER.querySelectorAll('.mtt-newsroom__sidebar-item[data-year]')

    if (YEARS.length > 0) {
      for (let i = 0; i < YEARS.length; i++) {
        const YEAR = YEARS[i]

        YEAR.addEventListener('click', () => {
          this.data.published = YEAR.getAttribute('data-year')
          this.data.pagenumber = 1
          $(YEAR).addClass('active').siblings().removeClass('active')
          this.loadPosts()
        })
      }
    }
  }

  categoriesHandler () {
    const CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-newsroom__sidebar-item[data-category]')

    if (CATEGORIES.length > 0) {
      for (let i = 0; i < CATEGORIES.length; i++) {
        const CAT = CATEGORIES[i]

        CAT.addEventListener('click', () => {
          this.data.category = CAT.getAttribute('data-category')
          this.data.pagenumber = 1
          $(CAT).addClass('active').siblings().removeClass('active')
          this.loadPosts()
        })
      }
    }
  }

  paginationHandler () {
    const PAGINATION_TOGGLES = this.WRAPPER.querySelectorAll('.mtt-pagination__toggle')

    if (PAGINATION_TOGGLES.length > 0) {
      for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
        const TOGGLE = PAGINATION_TOGGLES[i]

        TOGGLE.addEventListener('click', (e) => {
          e.preventDefault()
          this.data.pagenumber = TOGGLE.getAttribute('data-page')
          this.loadPosts()
        })
      }
    }
  }

  getFirstYear () {
    const ACTIVE_YEAR = this.WRAPPER.querySelector('.mtt-newsroom__sidebar-item[data-year].active')
    const YEAR = ACTIVE_YEAR ? ACTIVE_YEAR.getAttribute('data-year') : new Date().getFullYear()
    return parseInt(YEAR)
  }

  getFirstCategory () {
    const ACTIVE_CAT = this.WRAPPER.querySelector('.mtt-newsroom__sidebar-item[data-category].active')
    const CATEGORY = ACTIVE_CAT ? ACTIVE_CAT.getAttribute('data-category') : 0
    return parseInt(CATEGORY)
  }

  loadPosts () {
    this.beforeAjax()
    $.post(main_theme_objects.ajax_url, this.data,
      (response) => {
        if (response !== 0) {
          if (this.TARGET && 'markup' in response) this.TARGET.innerHTML = response.markup
          if (this.PAGINATION_TARGET && 'pagination' in response) this.PAGINATION_TARGET.innerHTML = response.pagination
          this.paginationHandler()
          this.afterAjax()
        }
      }
    )
  }

  beforeAjax () {
    this.showLoader()
  }

  afterAjax () {
    this.buildUrl()
    this.hideLoader()
    this.scrollTop()
  }

  showLoader () {
    this.LOADER && this.LOADER.classList.add('loader--show')
  }

  hideLoader () {
    this.LOADER && this.LOADER.classList.remove('loader--show')
  }

  buildUrl () {
    let parametersString = this.url
    const parameters = []

    // add pagenumber
    if ('pagenumber' in this.data && parseInt(this.data.pagenumber) > 1) {
      parametersString += `page/${this.data.pagenumber}/`
    }

    // add year
    if ('published' in this.data && parseInt(this.data.published) !== 0) {
      parameters.push(`published=${this.data.published}`)
    }

    // add cat
    if ('category' in this.data && parseInt(this.data.category) !== 0) {
      parameters.push(`category=${this.data.category}`)
    }

    if (parameters.length > 0) {
      for (let i = 0; i < parameters.length; i++) {
        parametersString += i === 0 ? '?' : '&'
        parametersString += parameters[i]
      }
    }

    window.history.pushState('newsroom', '', parametersString)
  }

  getScrollOffset () {
    let offset = 0
    const HEADER = document.getElementById('main_header')
    offset += HEADER ? HEADER.getBoundingClientRect().height : 0
    const ADMIN_BAR = document.getElementById('wpadminbar')
    offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
    return offset
  }

  scrollTop () {
    $('html, body').animate({
      scrollTop: $(this.WRAPPER).offset().top - this.getScrollOffset()
    }, 700)
  }
}
